module.exports = leftpad;

function leftpad (str, len, ch) {
  str = String(str);

  var i = -1;

  ch || (ch = ' ');
  len = len - str.length;


  while (++i < len) {
    str = ch + str;
  }

  return str;
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-types/~/babel-traverse/~/babel-code-frame/~/line-numbers/~/left-pad/index.js
 ** module id = 277
 ** module chunks = 0
 **/